import script from "./Chip.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chip.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
